import { notify } from "../../event-bus";
import Vue from "vue";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    user: {
      name: "",
      id: null,
    },
    users: {}
  },
  getters: {
    user: (state) => {
      return state.user;
    },
    username: (state) => {
      return state.user.name;
    },
    userId: (state) => {
      return state.user.id;
    },
  },
  actions: {
    saveUser({ commit }, payload) {
      return Vue.http
        .post(`${process.env.VUE_APP_BACKEND_APP}/api/users`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((response) => {
          commit("userData", response.data.user);
          router.push("/tables");
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
    deleteUser({ commit }, payload) {
      return Vue.http
        .delete(
          `${process.env.VUE_APP_BACKEND_APP}/api/users/${payload.userId}`,
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
            },
          }
        )
        .then(() => {
          commit("userData", {});
          commit("tables/leaveTable", {}, {root: true});
        })
        .catch((error) => {
          commit("userData", {});
          commit("tables/leaveTable", {}, {root: true});
          if (error.status != 401) {
            notify(error, "ERROR");
          }
        });
    },
    fetchUsers({ commit }, query) {
      return Vue.http
        .get(`${process.env.VUE_APP_BACKEND_APP}/api/users`, {
          params: query,
        })
        .then((response) => {
          commit("usersData", response.data);
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
    check({state, dispatch }) {
      return Vue.http
        .get(`${process.env.VUE_APP_BACKEND_APP}/api/users/` + state.user.id, {
          withCredentials: true 
        })
        .then(() => {
          return true;
        })
        .catch((error) => {
          if (error.status === 401) {
            // the 401 interceptor already cleared the session and routed to "/"
            return false;
          }
          const userData = {
            userId: state.user.id,
          };
          dispatch("deleteUser", userData).then(() => {
            router.push("/");
          });
          return false;
        });
    }
  },
  mutations: {
    userData(state, userData) {
      state.user = userData;
    },
    usersData(state, data) {
      state.users = data;
    },
    addedUser(state, data) {
      const userIndex = state.users.data.findIndex((user) => user.id === data.user.id);
      if (state.users.data && userIndex == -1) {
        state.users.data.unshift(data.user);
      }
    },
    deletedUser(state, data) {
      const userIndex = state.users.data.findIndex((user) => user.id === data.id);
      if (state.users.data && userIndex) {
        state.users.data.splice(
          userIndex,
          1
        );
      }
    }
  },
};
